/*
 * @Author       : qixiao
 * @Date         : 2023-05-13 10:56:05
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-16 11:31:09
 * @FilePath     : \hzs-Houtai\src\main.js
 * @Description  : 
 * 
 */
/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2022-02-19 19:14:34
 * @LastEditors: quwandong
 * @LastEditTime: 2023-03-24 19:12:40
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import http from '@/api/api'
import Bread from '@/components/Bread'
import VueQuillEditor from 'vue-quill-editor'
import '@/router/routerConfig' // 路由权限
// require styles 导入富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor /* { default global options } */)
// import * as Sentry from '@sentry/vue'
// import { BrowserTracing } from '@sentry/tracing'

Vue.component('Bread', Bread)

import '@/styles/reset.css'
import './assets/iconfont/iconfont.css'
import '@/styles/global.scss'
// 引入element-ui
import ElementUI from 'element-ui'

import sku from './assets/szoperative/sku.js'
Vue.prototype.$sku = sku
// 自定义主题色
import './styles/element-variables.scss'
import { dictMixin } from './utils/mixins'
Vue.use(ElementUI)

import axios from 'axios'
Vue.prototype.axios = axios

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.prototype.$http = http //将http挂载到vue的原型上
Vue.config.productionTip = false
Vue.config.logErrors = true

// 全局获取字典mixins
Vue.mixin(dictMixin)
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})
// Sentry.init({
//   Vue,
//   dsn: 'http://159814897e804bdc8d1010894277ffde@127.0.0.1:9000/2',
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ['localhost', '9696', /^\//],
//     }),
//   ],
//   tracesSampleRate: 1.0,
//   release: '0.0.1',
// })

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  },
}).$mount('#app')
